import { SidebarContext } from "@components:Sidebar/Sidebar.Context";
import {
  Box,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  SxProps,
  Typography,
} from "@mui/material";
import { ReactNode, useContext } from "react";

export interface SidebarMenuItemProps {
  children: ReactNode;
  icon?: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  borderRadius?: string;
  sx?: SxProps;
  fontSize?: string;
  selected?: boolean;
  hidden?: boolean;
}

export const SidebarMenuItem = ({
  children,
  icon,
  onClick,
  disabled,
  borderRadius = "8px",
  sx,
  fontSize = "14px",
  selected = false,
  hidden = false,
}: SidebarMenuItemProps) => {
  const sidebarContext = useContext(SidebarContext);

  if (hidden) {
    return null;
  }

  return (
    <Box
      className="Sidebar__MenuItem"
      sx={{
        ...sx,
      }}
    >
      <ListItemButton
        selected={selected}
        sx={{
          whiteSpace: "nowrap",
          marginBottom: "2px",
          padding: "10px",
          borderRadius: borderRadius,
          cursor: disabled ? "default" : "pointer",
          opacity: disabled ? "0.6" : "1",
          color: sidebarContext.itemTextColor,
          ".MuiListItemIcon-root": {
            color: sidebarContext.itemTextColor,
          },
          "&:hover": {
            backgroundColor: disabled
              ? "#fff"
              : sidebarContext.itemBackgroundColor + 20,
            color: sidebarContext.itemBackgroundColor,
            ".MuiListItemIcon-root": {
              color: sidebarContext.itemBackgroundColor,
            },
          },
          "&.Mui-selected": {
            color: sidebarContext.itemContrastTextColor,
            backgroundColor: sidebarContext.itemBackgroundColor,
            "&:hover": {
              backgroundColor: sidebarContext.itemBackgroundColor,
              color: sidebarContext.itemContrastTextColor,
            },
            ".MuiListItemIcon-root": {
              color: sidebarContext.itemContrastTextColor,
            },
          },

          display: "flex",
          gap: "10px",
        }}
        onClick={onClick}
      >
        {icon && (
          <ListItemIcon
            sx={{
              minWidth: "0px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
              marginBottom: "0px",
              padding: "0px",
              cursor: "pointer",
              color: "inherit",
            }}
          >
            {icon}
          </ListItemIcon>
        )}
        {!sidebarContext.isCollapse ? (
          <>
            <ListItemText
              sx={{
                my: 0,
              }}
            >
              <Typography
                fontSize={fontSize}
                sx={{
                  lineHeight: "1",
                }}
                variant="caption"
              >
                {children}
              </Typography>
            </ListItemText>
          </>
        ) : null}
      </ListItemButton>
    </Box>
  );
};
